import { useEffect, useState } from 'react'
import { LoadingOutlined } from '@ant-design/icons'

import { DownloadIcon } from '@/components/Icons'
import useAsync from '@/hooks/useAsync'
import usePermission from '@/hooks/usePermission'
import { ASYNC_STATUS } from '@/libs/constants'
import { MODULE_ORDER_RIGHTS } from '@/libs/constants/modulerights'
import { isValidArray } from '@/libs/utils/array'
import { downloadPDF, getInvoices } from '@/libs/utils/PDFHandler'
import { isStringNotEmpty } from '@/libs/utils/stringUltis'
import { toast } from '@/libs/utils/toast'

import DownloadModal from '../DownloadModal'
import styles from './DownloadButton.module.scss'

function DownloadButton({
  orderNumber = '',
  orderDate = '',
  referenceNumber = '',
  orderStatus = '',
  invoiceNumbers,
  renderItem,
}) {
  const [showModal, setShowModal] = useState(false)
  const { hasPermission: hasDownloadInvoicePermission } = usePermission(
    MODULE_ORDER_RIGHTS.DOWNLOAD_INVOICE,
  )

  const { execute, status, value } = useAsync(
    () => getInvoices(invoiceNumbers),
    false,
  )

  const isLoading = status === ASYNC_STATUS.PENDING

  useEffect(() => {
    if (status === ASYNC_STATUS.SUCCESS) {
      const { fileName, file } = isValidArray(value) ? value[0] : {}

      if (isStringNotEmpty(fileName) && isStringNotEmpty(file)) {
        downloadPDF({ fileName, file })
      } else {
        toast.error({ message: 'notification.error.downloadInvoice' })
      }
    } else if (status === 'error') {
      toast.error({ message: 'notification.error.downloadInvoice' })
    }
  }, [status, value])

  const onClick = () => {
    if (
      isValidArray(invoiceNumbers) && invoiceNumbers.length === 1 && hasDownloadInvoicePermission
    ) {
      execute()
    } else {
      setShowModal(true)
    }
  }

  return (
    <>
      {renderItem?.({ onClick, loading: isLoading }) || (
        <button className={styles.button} type="button" onClick={onClick}>
          {isLoading ? <LoadingOutlined /> : <DownloadIcon />}
        </button>
      )}
      {showModal && (
        <DownloadModal
          hasDownloadInvoicePermission={hasDownloadInvoicePermission}
          orderDate={orderDate}
          orderNumber={orderNumber}
          orderStatus={orderStatus}
          referenceNumber={referenceNumber}
          setShowModal={setShowModal}
          showModal={showModal}
        />
      )}
    </>
  )
}

export default DownloadButton
